/* PELUX · Chantier conversion du 14/10 — zone « haut » de la fiche du harnais
   (thème de test « page parfaite », review/cro-2026-10-14/CHARTE.md).
   Haut de fiche : galerie, titre et vignette de note, promesse, prix et « Livraison offerte », variantes et vignette de stock.
   Chargé en defer seulement sur la fiche du harnais, après pelux-preuve.js (layout/theme.liquid).
   Custom elements ou délégation sur le document : les blocs re-rendus (variantes, prix) remplacent
   leur DOM à chaque changement de variante. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------------------
     « Leurs photos » sur la galerie (snippets/pelux-cro-haut-galerie.liquid).
     La pastille ne porte aucune donnée : elle reflète les stories clients DÉJÀ rendues dans la
     colonne d'achat (bloc « Stories clients », source unique snippets/pelux-temoignages.liquid —
     vrais témoignages avec accord de publication, ou lots du thème de test). Elle reste
     masquée s'il n'y en a pas, ou si elles ne se voient pas (lots sur un thème publié :
     garde [data-pelux-lot] de layout/theme.liquid). Des stories du lot B → la pastille
     devient elle-même un lot (attribut + étiquette).
     Appui : la visionneuse des stories s'ouvre au premier témoignage (<pelux-stories>.ouvrir,
     assets/pelux-preuve.js) et rend le focus à la pastille en se fermant. Sans visionneuse
     utilisable : la page descend jusqu'aux stories.
     Visages : les trois premières vignettes des stories, en petite taille (96 px au lieu de 360) :
     asset_img_url (« _360x. ») ou image_url (« width=360 »).
     La pastille vit hors de la liste des médias (product-info.js la remplace au changement de
     couleur) : elle survit aux changements de variante.
     --------------------------------------------------------------------------- */
  function petite(url, largeur) {
    if (!url) return '';
    if (/_\d+x\./.test(url)) return url.replace(/_\d+x\./, '_' + largeur + 'x.');
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + largeur);
    return url;
  }

  function plusPetiteSource(img) {
    var meilleure = null;
    (img.getAttribute('srcset') || '').split(',').forEach(function (candidat) {
      var morceaux = candidat.trim().split(/\s+/);
      var largeur = parseInt(morceaux[1], 10);
      if (morceaux[0] && largeur && (!meilleure || largeur < meilleure.largeur)) {
        meilleure = { url: morceaux[0], largeur: largeur };
      }
    });
    return meilleure ? meilleure.url : img.getAttribute('src') || img.currentSrc || '';
  }

  function seVoit(el) {
    return !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  }

  if (window.customElements && !customElements.get('pelux-cro-photos')) {
    customElements.define('pelux-cro-photos', class extends HTMLElement {
      connectedCallback() {
        if (this.pret) return;
        this.pret = true;
        var self = this;
        // Une image plus tard : la garde des lots (classe pelux-lot-b posée dans le <head>)
        // et les styles sont en place, getClientRects dit vrai.
        requestAnimationFrame(function () { self.brancher(); });
      }

      brancher() {
        var racine = this.closest('product-info') || document;
        var stories = racine.querySelector('.product__info-container pelux-stories');
        var bloc = stories && (stories.closest('.pelux-stories') || stories);
        var items = stories ? stories.querySelectorAll('[data-story]') : [];
        var bouton = this.querySelector('[data-photos-ouvrir]');
        var visages = this.querySelector('[data-photos-visages]');
        if (!stories || !items.length || !bouton || !seVoit(bloc)) return; // rien à montrer

        for (var i = 0; i < items.length && i < 3; i++) {
          var vignette = items[i].querySelector('img');
          var src = vignette ? petite(plusPetiteSource(vignette), 96) : '';
          if (!src || !visages) continue;
          var visage = document.createElement('img');
          visage.src = src;
          visage.alt = '';
          visage.width = 30;
          visage.height = 30;
          visage.decoding = 'async';
          visages.appendChild(visage);
        }

        var modele = bouton.getAttribute('data-libelle') || '';
        if (modele) bouton.setAttribute('aria-label', modele.replace('[n]', items.length));

        if (bloc.hasAttribute('data-pelux-lot')) this.setAttribute('data-pelux-lot', '');

        bouton.addEventListener('click', function () {
          if (typeof stories.ouvrir === 'function' && stories.vue && typeof stories.vue.showModal === 'function') {
            stories.ouvrir(0, bouton);
          } else {
            var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            bloc.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'start' });
          }
        });
        this.hidden = false;
      }
    });
  }
})();
